<template>
  <div>
    <BaseOrderModal
      @closeOrder="openedOrder = ''"
      :orderUUID="openedOrder"
      v-model="showOrderModal"
    />
    <div class="dashboard">
      <div class="alerts " v-for="alert in alerts" :key="alert.message">
        <div
          class="alert bg-red-900 m-2 rounded-md p-2 text-white text-xs md:text-base"
          v-for="error in alert.data"
          :key="error.message"
        >
          ERROR! AVISAR A ANDRES - {{ alert.type }}: {{ error.message }}
        </div>
      </div>
      <a
        target="_blank"
        :href="unprintedOrdersLink"
        class="dark-button mx-2 mt-10"
      >
        Print unprinted orders
      </a>
      <div v-if="status && !loading">
        <div
          class="system-status"
          v-for="system in Object.keys(status)"
          :key="system"
        >
          <div class="item">
            Orders Export Error Status
            <table>
              <tr
                v-for="item in status[system].OrdersExportErrorstatus"
                :key="item.storeName"
              >
                <td>{{ item.storeName }}</td>
                <td>{{ item.orders }}</td>
              </tr>
            </table>
          </div>
          <div class="item">
            Orders To Export by Marketplace
            <table>
              <tr
                v-for="item in status[system].ordersToExportByMarketplace"
                :key="item.storeName"
              >
                <td>{{ item.storeName }}</td>
                <td>{{ item.orders }}</td>
                <td>
                  <a
                    v-if="!sendingOrders"
                    @click="sendOrders(system, item.marketplaceCode)"
                    class="default small"
                  >
                    Export {{ item.storeName }}
                  </a>
                </td>
              </tr>
            </table>
          </div>
          <div class="item">
            <h1>Total</h1>
            <h1>
              {{ status[system].ordersToExport }} Orders pending to export to
              {{ system }}
            </h1>
            <BaseACustom :loading="sendingOrders" @click="sendOrders(system)">
              Send All Orders To {{ system }}
            </BaseACustom>
          </div>
        </div>
      </div>
      <div>
        Load single order from shipstation
        {{ url }}/shipstation_api/get_order_from_shipstation/701-6923982-2574649
      </div>
      <div v-if="loading">
        Loading ...
      </div>
    </div>
    <BaseFlagsHistory @openOrder="openOrder" />
  </div>
</template>

<script>
import { getOrdersStatus, sendAllPendingOrders } from "@/api/SyncSystem.js";

export default {
  name: "dashboardPage",
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      status: null,
      loading: true,
      sendingOrders: false,
      showOrderModal: false,
      openedOrder: ""
    };
  },
  computed: {
    unprintedOrdersLink() {
      return `${process.env.VUE_APP_NKRSYNC_BE}orders/print_not_printed_invoices`;
    },
    alerts() {
      return this.$store.getters["general/getAlerts"];
    }
  },
  async mounted() {
    const ordersStatus = await getOrdersStatus();
    this.status = ordersStatus?.data;
    this.loading = false;
    this.$store.dispatch("general/updateAlerts");
    this.$store.dispatch("general/updateFlagsHistory");
  },
  methods: {
    openOrder(orderUUID) {
      this.openedOrder = orderUUID;
      this.showOrderModal = true;
    },
    logout() {
      this.$store.dispatch("auth/logOut");
      this.$router.push("/");
    },
    async sendOrders(systemCode, marketplace = null) {
      this.sendingOrders = true;
      const result = await sendAllPendingOrders(systemCode, marketplace).catch(
        e => {
          const errorMessage = e.response.data.message || "Error On request";
          this.$toast.open({
            message: errorMessage,
            type: "error",
            position: "top-right"
          });
        }
      );
      if (result?.results) {
        this.$toast.open({
          message: `Orders Sent succesfully: ${result.results.ordersSentSuccess}<br>Error sending Orders: ${result.results.ordersWithError}`,
          type: "success",
          position: "top-right"
        });
      }
      this.sendingOrders = false;
    }
  }
};
</script>
<style lang="scss">
.system-status {
  display: flex;
  flex-direction: row;
  padding: 25px;
  margin: 10px;
  .item {
    margin: 20px;
  }
}
</style>
